import styled from 'styled-components';

import { Avatar, AVATAR_SIZES } from 'ui/avatar';
import { Tooltip } from 'ui/tooltip';
import { localizeCompactDateTime } from 'utils/l10n';

import { User } from '../../../types';

const Container = styled.div`
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.values.half};
  display: flex;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export type UserInfo = {
  emailAddress: string;
  fullName?: string;
  avatarUrl?: string;
};

export type Props = {
  modifiedAt: string;
  modifiedBy: User;
};

export const testIds = {
  avatar: 'mbu-avatar',
  container: 'mbu-container',
  textContent: 'mbu-text-content',
};

export const ModifiedByUser = ({ modifiedBy, modifiedAt, ...otherProps }: Props) => {
  const [modifierFirstName, modifierLastName] = modifiedBy.fullName.split(' ');

  return (
    <Container data-test={testIds.container} {...otherProps}>
      <Tooltip tooltipContent={modifiedBy.fullName}>
        <Avatar
          data-test={testIds.avatar}
          firstName={modifierFirstName}
          imgSrc={modifiedBy.avatarUrl}
          lastName={modifierLastName}
          size={AVATAR_SIZES.SMALL}
        />
      </Tooltip>
      <TextContent data-test={testIds.textContent}>
        {localizeCompactDateTime(new Date(modifiedAt))}
      </TextContent>
    </Container>
  );
};
